// useScrollDirection.js
import { useEffect, useState } from "react";

export default function useScrollDirection() {
  const [direction, setDirection] = useState("down");

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const updateScrollDir = () => {
      const scrollY = window.scrollY;

      if (scrollY > lastScrollY) {
        setDirection("down");
      } else {
        setDirection("up");
      }

      lastScrollY = scrollY;
    };

    window.addEventListener("scroll", updateScrollDir);

    return () => window.removeEventListener("scroll", updateScrollDir);
  }, []);

  return direction;
}